/**
 * mtc-backoffice-api
 * MTC Backoffice Composite Api
 *
 * OpenAPI spec version: 0.1.0-SNAPSHOT
 * Contact: developers@greysystems.eu
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */


export interface SearchRequest { 
    fromSentAmount?: number;
    toSentAmount?: number;
    destinationCountry?: string;
    idAgent?: number;
    urn?: string;
    transactionCode?: string;
    localCustomerId?: string;
    remoteCustomerId?: string;
    blockedStatus?: SearchRequest.BlockedStatusEnum;
    watchedStatus?: SearchRequest.WatchedStatusEnum;
    statuses?: Array<SearchRequest.StatusesEnum>;
    fromDateTime?: Date;
    toDateTime?: Date;
    channel?: SearchRequest.ChannelEnum;
    page?: number;
    pageSize?: number;
}
export namespace SearchRequest {
    export type BlockedStatusEnum = 'Blocked' | 'Unblocked';
    export const BlockedStatusEnum = {
        Blocked: 'Blocked' as BlockedStatusEnum,
        Unblocked: 'Unblocked' as BlockedStatusEnum
    };
    export type WatchedStatusEnum = 'Watched' | 'Unwatched';
    export const WatchedStatusEnum = {
        Watched: 'Watched' as WatchedStatusEnum,
        Unwatched: 'Unwatched' as WatchedStatusEnum
    };
    export type StatusesEnum = 'Registered' | 'Cancelled' | 'CancelledImmediately' | 'Paid' | 'PaymentRollback';
    export const StatusesEnum = {
        Registered: 'Registered' as StatusesEnum,
        Cancelled: 'Cancelled' as StatusesEnum,
        CancelledImmediately: 'CancelledImmediately' as StatusesEnum,
        Paid: 'Paid' as StatusesEnum,
        PaymentRollback: 'PaymentRollback' as StatusesEnum
    };
    export type ChannelEnum = 'HomeTransfer' | 'Agent' | 'B2B';
    export const ChannelEnum = {
        HomeTransfer: 'HomeTransfer' as ChannelEnum,
        Agent: 'Agent' as ChannelEnum,
        B2B: 'B2B' as ChannelEnum
    };
}
